export enum PlanEnum {
  STARTER = "STARTER",
  BASIC = "BASIC",
  PREMIUM = "PREMIUM",
  BUSINESS = "BUSINESS",
}
